import { NgModule, Component, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmissionFrequency } from '../enums/gateway.enum';

@Pipe({
  name: "emissionFrequencyPipe"
})
export class EmissionFrequencyPipe implements PipeTransform {
  translation: any;

  constructor(private translate: TranslateService) {
    this.translate.get('Gateway').subscribe(
      data => {
        this.translation = data;
      }
    )
  }

  transform(value: any): string {
    let text;
    switch (value) {
      case EmissionFrequency.millisecond:
        text = this.translation.millisecond;
        break;
      case EmissionFrequency.second:
        text = this.translation.second;
        break;
      case EmissionFrequency.minute:
        text = this.translation.minute;
        break;
    }
    return text;
  }
}
